oyc.PageNav = {
  container: '.page-nav',
  titleContainer: '.page-title',
  item: '.page-nav details',
  attribute: 'open',
  manualState: null,
  userInteracted: false,

  init: function() {
    this.container = $(this.container);
    if (this.container.length > 0) {
      this.toggleEvents();

      $(window).on('resize', this.debounce(() => {
        this.manualState = null;
        this.userInteracted = false;
        this.toggleEvents();
      }, 250));
    }
  },

  toggleEvents: function() {
    const $details = this.container.find('details');
    const self = this;

    $details.off('toggle');
    $details.find('summary').off('click');
    $details.find('.page-nav-link').off('click');

    $details.find('summary').on('click', function(e) {
      self.userInteracted = true;
      self.manualState = !$details[0].open;
    });

    $details.on('toggle', function() {
      if (self.inAutoToggle) return;
    });

    $details.find('.page-nav-link').on('click', function() {
      if (!self.userInteracted || $(window).width() < 768) {
        $details.removeAttr('open');
      }
    });


    if ($(window).width() > 768) {
      if (this.manualState === null && !this.userInteracted) {
        $details.attr('open', true);
        this.container.addClass('is-summary-hide');
      }

      $(window).off('scroll.pageNav').on('scroll.pageNav', () => {
        const rect = this.container[0].getBoundingClientRect();
        const $titleEl = $(this.titleContainer);
        const $navEl = $(this.container);
        const defaultOffset = $navEl.length ? $navEl.offset().top : 0;
        const titleOffset = $titleEl.length ? $titleEl.offset().top : defaultOffset;
        const scrollY = window.scrollY;

        if (scrollY + 20 < titleOffset && rect.top > 180) {
          if (!this.userInteracted) {
            this.manualState = null;
          }
          if ($details.attr('open')) {
            this.container.addClass('is-summary-hide');
          }
        } else {
          this.container.removeClass('is-summary-hide');
        }

        if (this.manualState === null && !this.userInteracted) {
          this.inAutoToggle = true;

          if (rect.top <= 180) {
            if ($details.attr('open')) {
              $details.removeAttr('open');
            }
          } else {
            if (!$details.attr('open')) {
              $details.attr('open', true);
            }
          }

          this.inAutoToggle = false;
        }
      });
    } else {
      $details.removeAttr('open');
      this.container.removeClass('is-summary-hide');
      $(window).off('scroll.pageNav');
    }
  },

  debounce: function(func, delay) {
    let timer;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }
};
